"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _UIToolBar = _interopRequireDefault(require("UIComponents/nav/UIToolBar"));

var _UIToolBarGroup = _interopRequireDefault(require("UIComponents/nav/UIToolBarGroup"));

var _InlineTextInputWithValidation = _interopRequireDefault(require("lead-flows-ui/components/common/InlineTextInputWithValidation"));

var _NextButton = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/NextButton"));

var _SecondaryNavigationSave = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/SecondaryNavigationSave"));

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _DynoValidation = require("lead-flows-ui/constants/DynoValidation");

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _DynoValidationUtils = require("lead-flows-ui/utils/Validation/DynoValidationUtils");

var _AppLink = _interopRequireDefault(require("../../common/AppLink"));

var EDITOR_STEPS = Object.values(_DynoEditor.STEPS || {});

var TitleNavigationBar =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TitleNavigationBar, _PureComponent);
  (0, _createClass2.default)(TitleNavigationBar, null, [{
    key: "propTypes",
    get: function get() {
      return {
        addValidationError: _react.default.PropTypes.func.isRequired,
        currentStep: _react.default.PropTypes.oneOf(EDITOR_STEPS).isRequired,
        dyno: _react.default.PropTypes.object.isRequired,
        handleAdvanceStep: _react.default.PropTypes.func.isRequired,
        handleDeleteDraft: _react.default.PropTypes.func.isRequired,
        handlePublish: _react.default.PropTypes.func.isRequired,
        hasChanges: _react.default.PropTypes.bool.isRequired,
        lastSaveAt: _react.default.PropTypes.number,
        name: _react.default.PropTypes.string,
        removeValidationError: _react.default.PropTypes.func.isRequired,
        readOnly: _react.default.PropTypes.bool.isRequired,
        saving: _react.default.PropTypes.bool.isRequired,
        savingHasError: _react.default.PropTypes.bool.isRequired,
        savingRecentError: _react.default.PropTypes.object,
        scriptLoaderIsInstalled: _react.default.PropTypes.bool.isRequired,
        updateDyno: _react.default.PropTypes.func.isRequired,
        isUngatedForMergedDashboard: _react.default.PropTypes.bool.isRequired,
        validation: _react.default.PropTypes.object,
        redirectUrl: _react.default.PropTypes.string
      };
    }
  }]);

  function TitleNavigationBar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TitleNavigationBar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TitleNavigationBar).call(this, props));
    _this.handleNameChange = _this.handleNameChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TitleNavigationBar, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor." + suffix;
    }
  }, {
    key: "errorLangKey",
    value: function errorLangKey() {
      return this.langKey('leadFlowOptionsEditor.error.');
    }
  }, {
    key: "validateField",
    value: function validateField(dyno, validate) {
      var _this$props = this.props,
          addValidationError = _this$props.addValidationError,
          removeValidationError = _this$props.removeValidationError;
      var errors = validate(dyno, this.errorLangKey());
      var field = Object.keys(dyno)[0];
      removeValidationError(field);

      if (errors.length) {
        errors.forEach(function (error) {
          return addValidationError.apply(null, (0, _toConsumableArray2.default)(error));
        });
      }

      return errors;
    }
  }, {
    key: "handleNameChange",
    value: function handleNameChange(_ref) {
      var value = _ref.target.value;
      this.props.updateDyno({
        name: value
      });
      this.validateField({
        name: value
      }, _DynoValidationUtils.validateName);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentStep = _this$props2.currentStep,
          dyno = _this$props2.dyno,
          handleAdvanceStep = _this$props2.handleAdvanceStep,
          handleDeleteDraft = _this$props2.handleDeleteDraft,
          handlePublish = _this$props2.handlePublish,
          hasChanges = _this$props2.hasChanges,
          lastSaveAt = _this$props2.lastSaveAt,
          name = _this$props2.name,
          readOnly = _this$props2.readOnly,
          saving = _this$props2.saving,
          savingHasError = _this$props2.savingHasError,
          savingRecentError = _this$props2.savingRecentError,
          scriptLoaderIsInstalled = _this$props2.scriptLoaderIsInstalled,
          validation = _this$props2.validation,
          redirectUrl = _this$props2.redirectUrl,
          isUngatedForMergedDashboard = _this$props2.isUngatedForMergedDashboard;
      var optionsValidation = validation.options || {};
      var backLinkBody = isUngatedForMergedDashboard ? _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('secondaryNavigation.backToAllForms')
      }) : _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('secondaryNavigation.backToFlows')
      });
      return _react.default.createElement(_UIToolBar.default, {
        use: "dark"
      }, _react.default.createElement(_UIToolBarGroup.default, null, _react.default.createElement(_UIBackButton.default, {
        role: "presentation"
      }, redirectUrl ? _react.default.createElement("a", {
        className: "secondary-navigation__back-info",
        href: redirectUrl
      }, backLinkBody) : _react.default.createElement(_AppLink.default, {
        className: "secondary-navigation__back-info",
        href: (0, _RouteGenerators.getDynoListRoute)()
      }, backLinkBody))), _react.default.createElement(_UIToolBarGroup.default, null, _react.default.createElement("h1", null, _react.default.createElement(_InlineTextInputWithValidation.default, {
        className: "dyno-name",
        invalidMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(optionsValidation.name, {
          MAX_NAME_LENGTH: _DynoValidation.MAX_NAME_LENGTH
        }),
        isInvalid: !(0, _ValidationUtils.isValid)(optionsValidation, 'name'),
        onChange: this.handleNameChange,
        value: name
      }))), _react.default.createElement(_UIToolBarGroup.default, null, _react.default.createElement(_SecondaryNavigationSave.default, {
        dyno: dyno,
        hasChanges: hasChanges,
        handleDeleteDraft: handleDeleteDraft,
        lastSaveAt: lastSaveAt,
        readOnly: readOnly,
        saving: saving,
        savingHasError: savingHasError,
        savingRecentError: savingRecentError,
        validation: validation
      }), _react.default.createElement(_NextButton.default, {
        dyno: dyno,
        currentStep: currentStep,
        saving: saving,
        savingHasError: savingHasError,
        savingRecentError: savingRecentError,
        scriptLoaderIsInstalled: scriptLoaderIsInstalled,
        validation: validation,
        redirectUrl: redirectUrl,
        handleAdvanceStep: handleAdvanceStep,
        handlePublish: handlePublish
      })));
    }
  }]);
  return TitleNavigationBar;
}(_react.PureComponent);

exports.default = TitleNavigationBar;
module.exports = exports.default;